import { ChangeDetectionStrategy, Component, Input, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import type { WaterPriceLabelSaveRequest } from '@models/water-information';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalizedTextEditorComponent } from '@shared/components/localized-text-editor/localized-text-editor.component';
import type { PricingForm } from '../water-information-form.types';

@Component({
  selector: 'app-water-information-pricing-section',
  templateUrl: './water-information-pricing-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    TranslatePipe,
    LocalizedTextEditorComponent,
  ],
})
export class WaterInformationPricingSectionComponent {
  @Input({ required: true }) form!: FormGroup<PricingForm>;

  readonly priceLabels = input.required<WaterPriceLabelSaveRequest[]>();
  readonly priceLabelsChange = output<WaterPriceLabelSaveRequest[]>();

  readonly langs = ['nl', 'en', 'de', 'it', 'fr'];

  addPriceLabel(): void {
    this.priceLabelsChange.emit([
      ...this.priceLabels(),
      {
        id: null,
        labelNl: null,
        labelEn: null,
        labelDe: null,
        labelIt: null,
        labelFr: null,
        titleNl: null,
        titleEn: null,
        titleDe: null,
        titleIt: null,
        titleFr: null,
        subTitleNl: null,
        subTitleEn: null,
        subTitleDe: null,
        subTitleIt: null,
        subTitleFr: null,
        tablesNl: null,
        tablesEn: null,
        tablesDe: null,
        tablesIt: null,
        tablesFr: null,
      },
    ]);
  }

  removePriceLabel(index: number): void {
    this.priceLabelsChange.emit(this.priceLabels().filter((_, i) => i !== index));
  }

  setPriceLabelText(index: number, prefix: string, lang: string, value: string): void {
    const field = `${prefix}${lang.charAt(0).toUpperCase()}${lang.slice(1)}` as keyof WaterPriceLabelSaveRequest;
    const updated = this.priceLabels().map((p, i) => (i === index ? { ...p, [field]: value || null } : p));
    this.priceLabelsChange.emit(updated);
  }
}
